import React from 'react'
import { useMemo } from 'react'

import bunnyCarrot from '~/images/bunny-carrot.svg'

const getModifier = (indexOfChild, childrenCount) => {
  const halfCount = childrenCount / 2;
  if (indexOfChild % 2 === 0) {
    return indexOfChild <= halfCount ? 'left-bottom' : 'left-top';
  } else {
    return indexOfChild < halfCount ? 'right-bottom' : 'right-top';
  }
}

const ProductsBunny = ({ block }) => {
  const modifiers = useMemo(() => {
    const productsCount = block.product_list.length;
    const modifierAcc = [];

    for (let i = 1; i <= productsCount; i++) {
      let modifier = 'product--';
      modifier += getModifier(i, productsCount)
      modifierAcc.push(modifier);
    }

    return modifierAcc;
  }, [block]);

  return (
    <section className={`block ${block._template} ${block.css_class_name} ${block.list_size_class}`}>
      <div className="container">
        <div className="products">
          {block.product_list.map((product, index) => {
            if (product.tag) {
              if (product.tag.color === 'Blue') {
                product.tag.color_class = 'blue'
              }
              else {
                product.tag.color_class = 'orange'
              }
            }

            return <div key={index} className={`product product-${block.product_list.length}`}>
              <div className={`product-wr${product.url ? ' has-link' : ''} ${modifiers[index]}`}>
                {product.url && (<a href={product.url}></a>)}
                {(block.list_size_class) === 'list-small' ? (
                  <div className="image"><img src={bunnyCarrot} alt={product.title} title={product.title} loading="lazy" /></div>
                ) : (
                  <>
                    {product.icon && (
                      <div className="image"><img src={product.icon} alt={product.title} title={product.title} loading="lazy" /></div>
                    )}
                  </>
                )}

                <div className="product-content">
                  <h4>{product.title} {(product.tag && product.tag.text) && (<span className={product.tag.color_class}>{product.tag.text}</span>)}</h4>
                  {product.text && (<div className="text-formatted" dangerouslySetInnerHTML={{ __html: product.text }}></div>)}
                </div>
              </div>
            </div>
          })}
        </div>

        {block.image && (
          <img className={`card-image card-image-${block.product_list.length}`} src={block.image} alt={block.image_alt_text} text={block.image_alt_text} loading="lazy" />
        )}
      </div>
    </section>

  )
}

export default ProductsBunny
